export default "__VITE_ASSET__Q_kv1rA2__"